import { render, staticRenderFns } from "./ESitemapMenu.vue?vue&type=template&id=37a11d14"
import script from "./ESitemapMenu.vue?vue&type=script&lang=js"
export * from "./ESitemapMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a11d14')) {
      api.createRecord('37a11d14', component.options)
    } else {
      api.reload('37a11d14', component.options)
    }
    module.hot.accept("./ESitemapMenu.vue?vue&type=template&id=37a11d14", function () {
      api.rerender('37a11d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ESitemapMenu.vue"
export default component.exports